import { render, staticRenderFns } from "./CaseTimeButton.vue?vue&type=template&id=28c9bfed&"
import script from "./CaseTimeButton.vue?vue&type=script&lang=ts&"
export * from "./CaseTimeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports